import axios from '@/libs/http'

/**
 * 获取默认统计时间
 */
export const getDefaultTime = () => {
  return axios.request({
    url: '/s/k/wages/getDefaultTime',
    params: {
    },
    method: 'get'
  })
}

/**
 * 获取客服总金额
 */
export const getSumAmount = (startTime, endTime) => {
  return axios.request({
    url: '/s/k/wages/getSumAmount',
    params: {
      startTime,
      endTime
    },
    method: 'get'
  })
}

/**
 * 获取店员续单金额
 */
export const listClerkAmount = (startTime, endTime) => {
  return axios.request({
    url: '/s/k/wages/listClerkAmount',
    params: {
      startTime,
      endTime,
    },
    method: 'get'
  })
}

